
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","fill":"#1434CB","rx":"1"}}),_c('path',{attrs:{"fill":"#fff","d":"m15.713 2.697-4.975 11.608H7.492L5.045 5.04c-.15-.57-.278-.78-.73-1.02-.738-.391-1.957-.76-3.03-.987l.074-.337h5.225c.666 0 1.264.434 1.415 1.184l1.294 6.715 3.195-7.9h3.226z"}})])
          )
        }
      }
    